// extracted by mini-css-extract-plugin
export default {"tripleSpinnerContainer":"loader_tripleSpinnerContainer__BZ6cB","tripleSpinner":"loader_tripleSpinner__Szn17","spin":"loader_spin__n5pam"};